import { AppState } from '~src/bootstrap/redux/state/AppState';
import { Messages } from '~src/codegen/Localize';
import { editFlowTask } from '~src/flow/actions/RunFlowTaskMenuActions';
import { RunFlowTaskInfo } from '~src/flow/models/RunFlowTaskInfo';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { ManageRunFlowTaskActions, userHasManageRunFlowTaskPermissions } from '../utils/FlowTaskActionUtils';


export const EditFlowTaskAction: IEntityAction<RunFlowTaskInfo, ManageRunFlowTaskActions> = {
  name: EntityActionNames.TasksEdit,
  translateName: Messages.editTask_action,
  isVisible: (targetItems: RunFlowTaskInfo[]) => {
    return targetItems.length > 0;
  },
  isClickable: (availableActions: ManageRunFlowTaskActions, targetItems: RunFlowTaskInfo[], state: AppState) => {
    return targetItems.length === 1 && userHasManageRunFlowTaskPermissions(availableActions);
  },
  createReduxAction: (targetItems: RunFlowTaskInfo[]) => editFlowTask(targetItems)
};
